import src from "IMAGE";
export default { src, width: 810, height: 719, blurWidth: 0, blurHeight: 0};
